import styled from 'styled-components'

export const AccordionMain = styled.div`
  overflow: hidden;
  will-change: height;
`

export const AccordionContent = styled.div``
